// ----------------------------------------------------------------------- imports externos
import { useEffect, useState } from "react";

// ----------------------------------------------------------------------- imports internos
import {
  borrarLlave,
  crearLlave,
  fueCancelada,
  listarLlaves,
} from "../../services/acceso";
import { llavesDisponibles, olvidarLlave } from "../../shared/acceso";

const fecha = (iso) =>
  iso ? new Date(iso).toLocaleDateString("es-AR", { day: "2-digit", month: "2-digit", year: "2-digit" }) : "—";

/* Las llaves de acceso de la persona, en Preferencias: cuáles tiene, crear
 * una en este dispositivo y borrar las que ya no use. Se piden al abrir el
 * panel, no antes. */
const LlavesDeAcceso = ({ abierto }) => {
  const [llaves, setLlaves] = useState(null);
  const [aviso, setAviso] = useState("");
  const [ocupado, setOcupado] = useState(false);

  const traer = () =>
    listarLlaves()
      .then(setLlaves)
      .catch(() => setLlaves([]));

  useEffect(() => {
    if (abierto && llaves === null) traer();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [abierto]);

  const agregar = async () => {
    setAviso("");
    setOcupado(true);
    try {
      await crearLlave();
      setAviso("Llave creada.");
      await traer();
    } catch (e) {
      if (!fueCancelada(e)) setAviso("No se pudo crear. Probá de nuevo.");
    } finally {
      setOcupado(false);
    }
  };

  const borrar = async (id) => {
    setOcupado(true);
    try {
      await borrarLlave(id);
      const quedan = (llaves || []).filter((k) => k.id !== id);
      setLlaves(quedan);
      if (!quedan.length) olvidarLlave();
    } catch {
      setAviso("No se pudo borrar.");
    } finally {
      setOcupado(false);
    }
  };

  return (
    <div className="hub-pref">
      <div className="et">Llaves de acceso ({llaves ? llaves.length : "…"})</div>
      <p className="desc" style={{ fontSize: "12.5px", marginBottom: 8 }}>
        Para entrar sin clave, con la huella, la cara o el celular.
      </p>
      {(llaves || []).map((k) => (
        <div className="hub-fila" key={k.id} style={{ marginBottom: 6 }}>
          <div>
            {k.nombre || "Llave"}
            <div className="desc">
              Creada {fecha(k.creada)} · último uso {fecha(k.ultima)}
            </div>
          </div>
          <button
            className="hub-quitar"
            onClick={() => borrar(k.id)}
            disabled={ocupado}
            aria-label={`Borrar la llave ${k.nombre || ""}`}
          >
            Borrar
          </button>
        </div>
      ))}
      <button
        className="hub-instalar"
        onClick={agregar}
        disabled={ocupado || !llavesDisponibles()}
      >
        Agregar llave
      </button>
      {aviso && (
        <div className="hub-aviso" role="status">
          {aviso}
        </div>
      )}
    </div>
  );
};

export default LlavesDeAcceso;
